import { render, staticRenderFns } from "./bancoGeral.vue?vue&type=template&id=46c4a091&scoped=true&"
import script from "./bancoGeral.vue?vue&type=script&lang=js&"
export * from "./bancoGeral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c4a091",
  null
  
)

export default component.exports